import { Controller } from "@hotwired/stimulus";

// A "Back to ..." link that goes back in history when the previous page is on
// this site, so the browser's forward button keeps working. Otherwise (direct
// visit, link from elsewhere) it is an ordinary link to its href.
export default class extends Controller {
  go(event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!this.hasSameOriginHistory) return;

    event.preventDefault();
    window.history.back();
  }

  get hasSameOriginHistory() {
    if (window.history.length <= 1 || !document.referrer) return false;

    try {
      return new URL(document.referrer).origin === window.location.origin;
    } catch {
      return false;
    }
  }
}
